import React from 'react';
import useWindowSize from './useWindowSize';

function useResponsiveness() {
  const { width } = useWindowSize();

  const isDesktop = () => width >= 1024;

  const isTablet = () => width > 640 && width < 1024;

  const isMobile = () => width <= 640;

  return { isDesktop, isTablet, isMobile };
}

export default useResponsiveness;
